import type { ErrorComponentProps } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { AppButton } from "@/components/ui/primitives";

export const RouteError = ({ reset }: ErrorComponentProps) => {
  const { t } = useTranslation("common");

  return (
    <main className="app-page flex min-h-screen items-center justify-center px-4 py-12">
      <section className="app-panel-raised w-full max-w-lg space-y-4 p-6 text-center sm:p-8" role="alert" aria-labelledby="route-error-title" aria-describedby="route-error-description">
        <h1 id="route-error-title" className="font-[var(--ds-font-display)] text-[length:var(--ds-type-title-size)] font-medium leading-[var(--ds-type-title-line)] tracking-[var(--ds-type-title-tracking)] text-[var(--app-text)]">
          {t("errors.boundaryTitle")}
        </h1>
        <p id="route-error-description" className="text-base leading-6 text-[var(--app-text-secondary)]">
          {t("errors.boundaryBody")}
        </p>
        <AppButton tone="primary" onClick={reset}>
          {t("errors.reloadPage")}
        </AppButton>
      </section>
    </main>
  );
};
